import React, { useMemo, useState } from "react";
import { Box, Card, colors, Typography } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Drilldown from "highcharts/modules/drilldown.js";
import { useGetNCRAgeingAnalysisQuery } from "store/slices/apis/ncrLogApiSlice";
import { useParams } from "react-router-dom";
import NcrTrackerListPopUp from "./NcrTrackerListPopup";

if (typeof Drilldown === "function") {
    Drilldown(Highcharts);
}

const AgeingAnalysisChart = (props) => {
    const { columns } = props;
    const { projectId } = useParams();
    const [selectedAgeing, setSelectedAgeing] = useState(null);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [showTable, setShowTable] = useState(false)

    const { data: apiResponse, isLoading } = useGetNCRAgeingAnalysisQuery(projectId, {
        skip: !projectId,
    });

    const handleAgeingClick = (duration) => {
        setSelectedAgeing(duration);
        setShowTable(true)
    }

    const handleClose = () => {
        setShowTable(false);
    };

    const pieColors = [
        "#2CAFEE",
        "#57C1F3",
        "#80D2F8",
        "#AADFFB",
        "#1E96E1",
        "#147BC3",
        "#0C62A0",
        "#084B82",
    ];

    const chartData = useMemo(() => {
        return Array.isArray(apiResponse?.data) ? apiResponse?.data : [];
    }, [apiResponse]);

    const hasData = chartData.length > 0;

    const options = {
        chart: {
            type: "pie",
            height: 380,
        },
        colors: pieColors,
        title: {
            text: "",
        },

        credits: {
            enabled: false,
        },

        tooltip: {
            pointFormat: "<b>{point.y}</b> items",
            style: {
                color: "#7E7E7E",
                fontWeight: '500',
                fontFamily: "Outfit"
            }
        },

        plotOptions: {
            pie: {
                cursor: "pointer",
                point: {
                    events: {
                        click: function () {
                            handleAgeingClick(String(this.name));
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    format: "{point.name}: {point.y}",
                    style: {
                        color: "#7E7E7E",
                        fontWeight: '500',
                        fontFamily: "Outfit",
                        textOutline: 'none',
                        textShadow: 'none',
                        fontSize: '14px'
                    }
                },
            },
        },

        series: [
            {
                name: "Ageing",
                colorByPoint: true,
                data: chartData,
            },
        ],

        // drilldown: {
        //     series: [
        //         {
        //             id: "age-0-30",
        //             name: "0–30 Days",
        //             data: [
        //                 ["Mitigated", 25],
        //                 ["Non-Mitigated", 15],
        //             ],
        //         },
        //         {
        //             id: "age-30-60",
        //             name: "30–60 Days",
        //             data: [
        //                 ["Mitigated", 10],
        //                 ["Non-Mitigated", 15],
        //             ],
        //         },
        //         {
        //             id: "age-60-plus",
        //             name: "> 60 Days",
        //             data: [
        //                 ["Mitigated", 5],
        //                 ["Non-Mitigated", 10],
        //             ],
        //         },
        //     ],
        // },
    };

    return (
        <>
            <Card
                elevation={0}
                sx={{
                    borderRadius: "3px",
                    border: "1px solid #E2E8F0",
                    boxShadow: "0 2px 8px rgba(15, 23, 42, 0.05)",
                    width: '100%',
                }}
            >
                <Box sx={{
                    width: '100%',
                    borderBottom: "1px solid #E4E4E4",
                    px: 1.5,
                    py: 1.25,
                    mb: 0,
                    display: 'flex',
                    justifyContent: 'space-between'
                }}>
                    <Box>
                        <Typography variant="subtitle1" sx={{
                            fontFamily: "Outfit, sans-serif",
                            fontWeight: 600,
                            fontSize: '15px',
                            lineHeight: '21px',
                            letterSpacing: "0px",
                            mb: 0
                        }}>
                            Ageing Analysis of Open Items.
                        </Typography>
                        <Typography variant="subtitle1" sx={{
                            fontWeight: 500,
                            fontSize: '11px',
                            lineHeight: "16px",
                            color: "#7D7F81",
                            letterSpacing: "1%",
                            fontFamily: "Poppins, sans-serif",
                        }}>
                            Age Distribution of Outstanding NCRs
                        </Typography>
                    </Box>
                </Box>

                {isLoading && (
                    <Typography sx={{ textAlign: "center", mt: 4 }}>
                        Loading chart...
                    </Typography>
                )}

                {!isLoading && !hasData && (
                    <Typography sx={{ textAlign: "center", mt: 4 }}>
                        No data available
                    </Typography>
                )}

                {!isLoading && hasData > 0 && (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={options}
                        immutable={true}
                        allowChartUpdate={false}
                    />
                )}

            </Card>

            {
                showTable &&
                <NcrTrackerListPopUp
                    open={showTable}
                    data={{ Ageing: String(selectedAgeing || "") }}
                    handleClose={handleClose}
                    columns={columns} />
            }
        </>
    );
};

export default AgeingAnalysisChart;
